<template>
  <v-dialog
    v-model="dialog"
    :fullscreen="$vuetify.breakpoint.smAndDown"
    persistent
    width="1200"
  >
    <v-card width="1200" class="mx-auto">
      <v-toolbar>
        <v-toolbar-title class="title">
          <span>
            {{ $t("promotionRules") }}
          </span>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="closeDialog">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text class="caption pa-6 pt-4">
        <div v-html="promotion.rules" />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  props: ["dialog", "promotion"],

  methods: {
    closeDialog() {
      this.$emit("closeDialog");
    },
  },
};
</script>
